<!-- <mat-card class="ie-fix" fxLayout="column" [fxShow.xs]="false"> -->
    <div class="ie-fix" fxLayout="column">
        <mat-card-title><b>Login</b></mat-card-title>
        <form [formGroup]="externalLoginForm">
            <mat-card-subtitle *ngIf="isTryAgain" style="color:red"><i>* Invalid Username/Password!</i></mat-card-subtitle>
            <mat-form-field>
                <input type="text" matInput placeholder="Email" formControlName="email">
            </mat-form-field>
            <mat-form-field>
                <input type="password" matInput placeholder="Password" formControlName="password">
            </mat-form-field>
            <div fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="center center">
                <button mat-raised-button (click)="login()" [disabled]="externalLoginForm.invalid"
                    class="login-button" color="primary">LOGIN</button>
                <button mat-raised-button (click)="logout()" class="login-button" color="warn">LOGOUT</button>
            </div>
        </form>
    </div>
    
    <!-- </mat-card> -->